import { Injectable, OnDestroy } from '@angular/core';
import { BaseDestroyable } from '@core/base-destroyable';
import { GlobalSettingsService } from '@core/globalSettings.service';
import { TimberService } from '@logging/timber.service';
import { WindowsApplications } from '@shared/windowsAppButton/WindowsApplications';
import { WindowsApplicationStore } from 'app/settings/state/windows-application.store';
import { Observable, of } from 'rxjs';
import { distinctUntilChanged, filter, map, mergeMap, takeUntil, tap } from 'rxjs/operators';
import { SoftwareOptionsService } from '@core/companySoftwareOptions/service/softwareOptions.service';
import { SoftwareOptionsForCompany } from '@shared/enums';

@Injectable({
	providedIn: 'root',
})
export class WindowsApplicationService extends BaseDestroyable implements OnDestroy {

	constructor(
		private globalSettingsService: GlobalSettingsService,
		private softwareOptionsService: SoftwareOptionsService,
		private store: WindowsApplicationStore,
		private timberService: TimberService
	) {
		super();
		this.globalSettingsService.contextChanged
			.pipe(
				map((context) => context.companyId),
				filter((companyId) => !!companyId),
				distinctUntilChanged(),
				mergeMap((companyId) => this.setApplications(companyId)),
				tap(_ => this.setPromptLogin(true)),
				takeUntil(this.componentAlive$)
			)
			.subscribe();
	}

	setApplicationsIfNeed(): Observable<any> {
		if (this.store.getValue().areApplicationsSet) {
			return of(null);
		}
		return this.setApplications(this.globalSettingsService.get().selectedCompanyId);	}

	setPromptLogin(value: boolean) {
		this.store.update(currentValue => ({
			...currentValue, promptLogin: value
		}));
	}

	private setApplications(currentCompanyId: number): Observable<any> {
		return this.softwareOptionsService
			.getCompanySoftwareOptionsKeyValuePair(currentCompanyId)
			.pipe(
				tap((softwareOptions) => {
					const applications = [
						WindowsApplications.Iosim,
						WindowsApplications.IosimPa,
						WindowsApplications.IosimCa,
						WindowsApplications.IosimGo,
						WindowsApplications.IosimPro
					];

					if (!Object.values(softwareOptions).includes(SoftwareOptionsForCompany.cswo_Hide_OrthoCAD_Show_3DM)) {
						applications.push(WindowsApplications.Orthocad);
					}

					this.timberService.debug(`Applications set for company ${currentCompanyId}`, {
						module: WindowsApplicationService.name
					});

					this.store.update(() => ({
						applications,
						areApplicationsSet: true
					}));
				})
			);
	}
}
